import { submit, change } from 'redux-form';
import { CLEANING_FEE_FORM } from '../constants';

const onChangeCleaningFeeForm = (newValue, dispatch) => {
  if (('DEACTIVATED' === newValue)) {
    dispatch(change(CLEANING_FEE_FORM, 'cleaning_fee.value', null));
    return setTimeout(() => dispatch(submit(CLEANING_FEE_FORM)), 1);
  }
};

export default onChangeCleaningFeeForm;
